import axiosApi from '../api/axiosApi';
import { GET_USERS, POST_USER, UPDATE_USER } from '../common/constants/constants';
import { Users } from '../common/types/types';

class UsersService {
  getUsers() {
    return axiosApi.get(GET_USERS);
  }
  addUser(request: Partial<Users>) {
    return axiosApi.post(POST_USER, request);
  }
  updateUser(request: Partial<Users>) {
    return axiosApi.put(UPDATE_USER + '/' + request.id, request);
  }
}

export default new UsersService();
